import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { VoteForm } from '../../Forms/VoteForm';
import { FarmFragment, SearchPageFragment } from '../../../generated/types';
import { LocationSearch } from '../../Common/LocationSearch';

interface AskLocationModalProps {
  data: SearchPageFragment;
  isOpen: boolean;
  onClose: () => void;
}

export const AskLocationModal: FC<AskLocationModalProps> = ({
  isOpen,
  onClose,
  data,
}) => {
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Wo möchten Sie suchen?</ModalHeader>
        <ModalBody pb={6}>
          <LocationSearch
            value={''}
            onInputChange={() => {}}
            onSubmit={() => {
              onClose();
            }}
            width="100%"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
